import jQuery from 'jquery'
import Isotope from 'isotope-layout'
import jQueryBridget from 'jquery-bridget'

jQueryBridget('isotope', Isotope, jQuery)
